module.exports = __webpack_public_path__ + "static/media/lensfest_globe.e77213d7.png";